import styled from '../../../../../theme/styled';

/*
 The CTA link buttons style on safari is not consistent with the design system,
 hence -webkit-appearance needs to be set to none.
*/
const StatusPageWrapper = styled.div`
  width: 100%;
  .kyc-status-page-styled-page {
    a[type='button'] {
      -webkit-appearance: none;
    }
    overflow: visible;
  }
`;

const VerificationTabContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default {
  StatusPageWrapper,
  VerificationTabContentWrapper,
};
